import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";
import { Button, FlexRowCenter, FormField, SingleSelect, Text, TextField } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React from "react";
import { useSnapshotTemplateStore } from "../SnapshotTemplateStore";
import { REQUIRED_LABEL } from "../snapshotUtils";

export const TemplateName = observer(() => {
	const store = useSnapshotTemplateStore();
	const { setTemplateName, templateName, saveErrorMessage } = store;
	return (
	    <FormField
	        control={(
	            <TextField
	                autoFocus
					error={!!saveErrorMessage}
	                fullWidth
	                onChange={setTemplateName}
	                placeholderRes="3DTemplateName"
	                value={templateName}
	            />
	        )}
	        fullWidth
	        invalidMessage={saveErrorMessage}
	        label={<Text bold res="SnapshotTemplate.Name" />}
	        labelPlacement="top"
	        required
			sx={REQUIRED_LABEL}
	    />
	);
});

export const TemplateDescription = observer(() => {
	const store = useSnapshotTemplateStore();
	const { templateDescription, setTemplateDescription } = store;
	return (
		<FormField
			control={(
				<TextField
					fullWidth
					onChange={setTemplateDescription}
					placeholderRes="Description"
					value={templateDescription}
				/>
			)}
			fullWidth
			label={<Text bold res="Description" />}
			labelPlacement="top"
		/>
	);
});

export const TemplateSelect = observer(() => {
	const store = useSnapshotTemplateStore();
	const {
		filteredTemplateOptions,
		setSelectedTemplate,
		selectedTemplate,
		userCanResetTemplate,
		updateTemplateDefinedOptions,
	} = store;

	return (
		<FormField
			control={(
				<SingleSelect
					onChange={setSelectedTemplate}
					options={filteredTemplateOptions}
					placeHolderRes="3DSelectTemplate"
					value={selectedTemplate}
				/>
			)}
			fullWidth
			label={(
				<FlexRowCenter justifyContent="space-between">
					<Text bold res="SnapshotTemplate.Name" />
					<Button
						design="link"
						disabled={!userCanResetTemplate}
						onClick={updateTemplateDefinedOptions}
						res="Reset"
						resParams={["Button"]}
						startIcon={<ReplayOutlinedIcon />}
					/>
				</FlexRowCenter>
			)}
			labelPlacement="top"
			labelStyle={{ width: "100%" }}
		/>
	);
});